module.exports = __webpack_public_path__ + "img/16_53.bb9efb1f.png";